export default __webpack_public_path__ + "static/media/process.22f0b9c5.svg";